/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lucio API
 * Lucio AI Outlook Add-in Backend API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorResponse,
  GetAuthMe200,
  PostAuthConnectMailbox200,
  PostAuthConnectMailboxBody,
  PostAuthConnectMailboxTicket201,
  PostAuthConnectMailboxTicketBody,
  PostAuthConnectMailboxTicketStatus200,
  PostAuthConnectMailboxTicketStatusBody,
  PostAuthConnectMailboxViaTicket200,
  PostAuthConnectMailboxViaTicketBody,
  PostAuthDeviceExchange201,
  PostAuthDeviceHandoff201,
  PostAuthDeviceHandoffBody,
  PostAuthDeviceHandoffClaim201,
  PostAuthDeviceHandoffClaimBody,
  PostAuthDeviceRefresh200,
  PostAuthDeviceRefreshBody,
  PostAuthDeviceRevoke200,
  PostAuthDeviceRevokeBody,
  PostAuthDisconnectMailbox200,
  ValidationErrorResponse
} from '../lucioAPI.schemas';

import { customInstance } from '../../mutator';




/**
 * Exchange a bootstrap Clerk session JWT (Authorization header) for a durable opaque device token. Used by Outlook on the web, where Clerk cookies are blocked in the taskpane iframe.
 * @summary Exchange bootstrap JWT for a device token
 */
export const postAuthDeviceExchange = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthDeviceExchange201>(
      {url: `/auth/device/exchange`, method: 'POST', signal
    },
      );
    }
  


export const getPostAuthDeviceExchangeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceExchange>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceExchange>>, TError,void, TContext> => {

const mutationKey = ['postAuthDeviceExchange'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthDeviceExchange>>, void> = () => {
          

          return  postAuthDeviceExchange()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthDeviceExchangeMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthDeviceExchange>>>
    
    export type PostAuthDeviceExchangeMutationError = ErrorResponse

    /**
 * @summary Exchange bootstrap JWT for a device token
 */
export const usePostAuthDeviceExchange = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceExchange>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthDeviceExchange>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAuthDeviceExchangeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Mint a fresh short-lived Clerk session JWT from a device token. Re-checks org access on every refresh so revocation is enforced on the device path.
 * @summary Refresh access token from device token
 */
export const postAuthDeviceRefresh = (
    postAuthDeviceRefreshBody: PostAuthDeviceRefreshBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthDeviceRefresh200>(
      {url: `/auth/device/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthDeviceRefreshBody, signal
    },
      );
    }
  


export const getPostAuthDeviceRefreshMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceRefresh>>, TError,{data: PostAuthDeviceRefreshBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceRefresh>>, TError,{data: PostAuthDeviceRefreshBody}, TContext> => {

const mutationKey = ['postAuthDeviceRefresh'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthDeviceRefresh>>, {data: PostAuthDeviceRefreshBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthDeviceRefresh(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthDeviceRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthDeviceRefresh>>>
    export type PostAuthDeviceRefreshMutationBody = PostAuthDeviceRefreshBody
    export type PostAuthDeviceRefreshMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Refresh access token from device token
 */
export const usePostAuthDeviceRefresh = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceRefresh>>, TError,{data: PostAuthDeviceRefreshBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthDeviceRefresh>>,
        TError,
        {data: PostAuthDeviceRefreshBody},
        TContext
      > => {

      const mutationOptions = getPostAuthDeviceRefreshMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Tear down a device session (and its underlying Clerk session) on sign-out.
 * @summary Revoke a device session
 */
export const postAuthDeviceRevoke = (
    postAuthDeviceRevokeBody: PostAuthDeviceRevokeBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthDeviceRevoke200>(
      {url: `/auth/device/revoke`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthDeviceRevokeBody, signal
    },
      );
    }
  


export const getPostAuthDeviceRevokeMutationOptions = <TError = ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceRevoke>>, TError,{data: PostAuthDeviceRevokeBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceRevoke>>, TError,{data: PostAuthDeviceRevokeBody}, TContext> => {

const mutationKey = ['postAuthDeviceRevoke'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthDeviceRevoke>>, {data: PostAuthDeviceRevokeBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthDeviceRevoke(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthDeviceRevokeMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthDeviceRevoke>>>
    export type PostAuthDeviceRevokeMutationBody = PostAuthDeviceRevokeBody
    export type PostAuthDeviceRevokeMutationError = ValidationErrorResponse

    /**
 * @summary Revoke a device session
 */
export const usePostAuthDeviceRevoke = <TError = ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceRevoke>>, TError,{data: PostAuthDeviceRevokeBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthDeviceRevoke>>,
        TError,
        {data: PostAuthDeviceRevokeBody},
        TContext
      > => {

      const mutationOptions = getPostAuthDeviceRevokeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Store a completed login under the reference to a taskpane-generated handoff id (bootstrap Clerk session JWT in the Authorization header). Lets the login dialog deliver its result over the backend when the window handle back to the taskpane was severed, or when the dialog has no storage of its own to remember the attempt with. Two different logins stored under one reference make it unclaimable, so a plant cannot displace the real one.
 * @summary Store a login handoff
 */
export const postAuthDeviceHandoff = (
    postAuthDeviceHandoffBody: PostAuthDeviceHandoffBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthDeviceHandoff201>(
      {url: `/auth/device/handoff`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthDeviceHandoffBody, signal
    },
      );
    }
  


export const getPostAuthDeviceHandoffMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceHandoff>>, TError,{data: PostAuthDeviceHandoffBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceHandoff>>, TError,{data: PostAuthDeviceHandoffBody}, TContext> => {

const mutationKey = ['postAuthDeviceHandoff'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthDeviceHandoff>>, {data: PostAuthDeviceHandoffBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthDeviceHandoff(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthDeviceHandoffMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthDeviceHandoff>>>
    export type PostAuthDeviceHandoffMutationBody = PostAuthDeviceHandoffBody
    export type PostAuthDeviceHandoffMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Store a login handoff
 */
export const usePostAuthDeviceHandoff = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceHandoff>>, TError,{data: PostAuthDeviceHandoffBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthDeviceHandoff>>,
        TError,
        {data: PostAuthDeviceHandoffBody},
        TContext
      > => {

      const mutationOptions = getPostAuthDeviceHandoffMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Claim a login handoff: mints a device session for the login the dialog stored. Single-use; the handoff id is the credential. Org access is re-checked before anything is issued.
 * @summary Claim a login handoff for a device token
 */
export const postAuthDeviceHandoffClaim = (
    postAuthDeviceHandoffClaimBody: PostAuthDeviceHandoffClaimBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthDeviceHandoffClaim201>(
      {url: `/auth/device/handoff/claim`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthDeviceHandoffClaimBody, signal
    },
      );
    }
  


export const getPostAuthDeviceHandoffClaimMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceHandoffClaim>>, TError,{data: PostAuthDeviceHandoffClaimBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceHandoffClaim>>, TError,{data: PostAuthDeviceHandoffClaimBody}, TContext> => {

const mutationKey = ['postAuthDeviceHandoffClaim'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthDeviceHandoffClaim>>, {data: PostAuthDeviceHandoffClaimBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthDeviceHandoffClaim(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthDeviceHandoffClaimMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthDeviceHandoffClaim>>>
    export type PostAuthDeviceHandoffClaimMutationBody = PostAuthDeviceHandoffClaimBody
    export type PostAuthDeviceHandoffClaimMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Claim a login handoff for a device token
 */
export const usePostAuthDeviceHandoffClaim = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDeviceHandoffClaim>>, TError,{data: PostAuthDeviceHandoffClaimBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthDeviceHandoffClaim>>,
        TError,
        {data: PostAuthDeviceHandoffClaimBody},
        TContext
      > => {

      const mutationOptions = getPostAuthDeviceHandoffClaimMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Retrieve the currently authenticated user profile. `user` is null until a mailbox has been connected; `graphTokenActive` is false when the Graph credential needs reconnecting.
 * @summary Get current user
 */
export const getAuthMe = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAuthMe200>(
      {url: `/auth/me`, method: 'GET', signal
    },
      );
    }
  



export const getGetAuthMeQueryKey = () => {
    return [
    `/auth/me`
    ] as const;
    }

    
export const getGetAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMe>>> = ({ signal }) => getAuthMe(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthMe>>>
export type GetAuthMeQueryError = ErrorResponse


export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getAuthMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getAuthMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user
 */

export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Connect (or reconnect) the signed-in Clerk user’s mailbox. The body carries a Microsoft identity token acquired via MSAL; the backend verifies it, exchanges it for a Graph credential via OBO, and persists it for background jobs.
 * @summary Connect mailbox
 */
export const postAuthConnectMailbox = (
    postAuthConnectMailboxBody: PostAuthConnectMailboxBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthConnectMailbox200>(
      {url: `/auth/connect-mailbox`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthConnectMailboxBody, signal
    },
      );
    }
  


export const getPostAuthConnectMailboxMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailbox>>, TError,{data: PostAuthConnectMailboxBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailbox>>, TError,{data: PostAuthConnectMailboxBody}, TContext> => {

const mutationKey = ['postAuthConnectMailbox'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthConnectMailbox>>, {data: PostAuthConnectMailboxBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthConnectMailbox(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthConnectMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthConnectMailbox>>>
    export type PostAuthConnectMailboxMutationBody = PostAuthConnectMailboxBody
    export type PostAuthConnectMailboxMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Connect mailbox
 */
export const usePostAuthConnectMailbox = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailbox>>, TError,{data: PostAuthConnectMailboxBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthConnectMailbox>>,
        TError,
        {data: PostAuthConnectMailboxBody},
        TContext
      > => {

      const mutationOptions = getPostAuthConnectMailboxMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Issue a single-use ticket that lets the Connect Mailbox dialog window complete the link on its own. Needed because identity providers that send a Cross-Origin-Opener-Policy header sever the taskpane’s handle on that window, leaving the token the user earned with no way back.
 * @summary Issue a connect-mailbox ticket
 */
export const postAuthConnectMailboxTicket = (
    postAuthConnectMailboxTicketBody: PostAuthConnectMailboxTicketBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthConnectMailboxTicket201>(
      {url: `/auth/connect-mailbox-ticket`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthConnectMailboxTicketBody, signal
    },
      );
    }
  


export const getPostAuthConnectMailboxTicketMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailboxTicket>>, TError,{data: PostAuthConnectMailboxTicketBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailboxTicket>>, TError,{data: PostAuthConnectMailboxTicketBody}, TContext> => {

const mutationKey = ['postAuthConnectMailboxTicket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthConnectMailboxTicket>>, {data: PostAuthConnectMailboxTicketBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthConnectMailboxTicket(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthConnectMailboxTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthConnectMailboxTicket>>>
    export type PostAuthConnectMailboxTicketMutationBody = PostAuthConnectMailboxTicketBody
    export type PostAuthConnectMailboxTicketMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Issue a connect-mailbox ticket
 */
export const usePostAuthConnectMailboxTicket = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailboxTicket>>, TError,{data: PostAuthConnectMailboxTicketBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthConnectMailboxTicket>>,
        TError,
        {data: PostAuthConnectMailboxTicketBody},
        TContext
      > => {

      const mutationOptions = getPostAuthConnectMailboxTicketMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * How the Connect Mailbox dialog’s own completion attempt ended, for the taskpane that lost its window handle. `pending` until the dialog’s call lands; afterwards mirrors the recorded outcome so a 409 linking conflict or a 403 denial isn’t reported to the user as a cancellation.
 * @summary Poll a connect-mailbox ticket’s outcome
 */
export const postAuthConnectMailboxTicketStatus = (
    postAuthConnectMailboxTicketStatusBody: PostAuthConnectMailboxTicketStatusBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthConnectMailboxTicketStatus200>(
      {url: `/auth/connect-mailbox-ticket/status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthConnectMailboxTicketStatusBody, signal
    },
      );
    }
  


export const getPostAuthConnectMailboxTicketStatusMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailboxTicketStatus>>, TError,{data: PostAuthConnectMailboxTicketStatusBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailboxTicketStatus>>, TError,{data: PostAuthConnectMailboxTicketStatusBody}, TContext> => {

const mutationKey = ['postAuthConnectMailboxTicketStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthConnectMailboxTicketStatus>>, {data: PostAuthConnectMailboxTicketStatusBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthConnectMailboxTicketStatus(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthConnectMailboxTicketStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthConnectMailboxTicketStatus>>>
    export type PostAuthConnectMailboxTicketStatusMutationBody = PostAuthConnectMailboxTicketStatusBody
    export type PostAuthConnectMailboxTicketStatusMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Poll a connect-mailbox ticket’s outcome
 */
export const usePostAuthConnectMailboxTicketStatus = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailboxTicketStatus>>, TError,{data: PostAuthConnectMailboxTicketStatusBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthConnectMailboxTicketStatus>>,
        TError,
        {data: PostAuthConnectMailboxTicketStatusBody},
        TContext
      > => {

      const mutationOptions = getPostAuthConnectMailboxTicketStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Connect a mailbox from the dialog window, authenticated by a single-use ticket rather than a Clerk session. The mailbox is still proven by the Microsoft identity token, which is verified independently; the ticket only names the account to link it to.
 * @summary Connect mailbox with a ticket
 */
export const postAuthConnectMailboxViaTicket = (
    postAuthConnectMailboxViaTicketBody: PostAuthConnectMailboxViaTicketBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthConnectMailboxViaTicket200>(
      {url: `/auth/connect-mailbox-via-ticket`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthConnectMailboxViaTicketBody, signal
    },
      );
    }
  


export const getPostAuthConnectMailboxViaTicketMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailboxViaTicket>>, TError,{data: PostAuthConnectMailboxViaTicketBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailboxViaTicket>>, TError,{data: PostAuthConnectMailboxViaTicketBody}, TContext> => {

const mutationKey = ['postAuthConnectMailboxViaTicket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthConnectMailboxViaTicket>>, {data: PostAuthConnectMailboxViaTicketBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthConnectMailboxViaTicket(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthConnectMailboxViaTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthConnectMailboxViaTicket>>>
    export type PostAuthConnectMailboxViaTicketMutationBody = PostAuthConnectMailboxViaTicketBody
    export type PostAuthConnectMailboxViaTicketMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Connect mailbox with a ticket
 */
export const usePostAuthConnectMailboxViaTicket = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthConnectMailboxViaTicket>>, TError,{data: PostAuthConnectMailboxViaTicketBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthConnectMailboxViaTicket>>,
        TError,
        {data: PostAuthConnectMailboxViaTicketBody},
        TContext
      > => {

      const mutationOptions = getPostAuthConnectMailboxViaTicketMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Disconnect the mailbox: soft-deletes the stored Graph credential, stopping background sync and automations until the mailbox is reconnected. The Clerk session is untouched.
 * @summary Disconnect mailbox
 */
export const postAuthDisconnectMailbox = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthDisconnectMailbox200>(
      {url: `/auth/disconnect-mailbox`, method: 'POST', signal
    },
      );
    }
  


export const getPostAuthDisconnectMailboxMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDisconnectMailbox>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthDisconnectMailbox>>, TError,void, TContext> => {

const mutationKey = ['postAuthDisconnectMailbox'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthDisconnectMailbox>>, void> = () => {
          

          return  postAuthDisconnectMailbox()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthDisconnectMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthDisconnectMailbox>>>
    
    export type PostAuthDisconnectMailboxMutationError = ErrorResponse

    /**
 * @summary Disconnect mailbox
 */
export const usePostAuthDisconnectMailbox = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthDisconnectMailbox>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthDisconnectMailbox>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAuthDisconnectMailboxMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    